import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PACKAGE_EDIT, PACKAGE_VIEW_TABS } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import { getCurrencyNameFromCode } from '../../../../../utils/commonUtils';
import {
  allPackagesSelector,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import './Package-View.scss';

const PackageView = (props) => {
  const { packObj, onViewToggle, toggleDrawer, selectedHotel, permissions } = props;
  const [selectedPackage, setSelectedPackage] = useState(packObj);
  const [tabValue, setTabValue] = useState(0);
  const currency = useSelector(selectedHotelCurrencySelector);
  const originalPackages = useSelector(allPackagesSelector);

  useEffect(() => {
    // retreiving selected category details from api
    const catObj = {
      ...originalPackages.find((pack) => pack.id === packObj.id),
    };
    setSelectedPackage(catObj);
  }, [selectedHotel, originalPackages]);

  const onClickEdit = (event) => {
    toggleDrawer(PACKAGE_EDIT, true, selectedPackage);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12 mb-4'>
                <span className='page-title-secondary'>Details</span>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Package Name</div>
                <div className='details-value preview-breaks'>{selectedPackage.name}</div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Status</div>
                <div className='details-value'>
                  <div
                    className={`${
                      selectedPackage.isActive ? 'pill-active' : 'pill-inactive'
                    } col-md-2 pill-text pill mt-3`}
                  >
                    {selectedPackage.isActive ? 'Active' : 'Inactive'}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Package Code</div>
                <div className='details-value'>{selectedPackage.code}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>{selectedPackage.description}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Cost per night</div>
                <div className='details-value'>
                  {getCurrencyNameFromCode(currency)} {selectedPackage.costPerNight}
                </div>
              </div>
            </div>
          </>
        )}
        {tabValue === 1 && (
          <div className='row pt-4 px-3'>
            <MediaViewer
              images={selectedPackage.images || []}
              enabledMediaTabs={['image']}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {selectedPackage && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={PACKAGE_VIEW_TABS}
          onViewToggle={onViewToggle}
          title={selectedPackage.name}
          createdUserId={selectedPackage.createdBy}
          isEditable={
            permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-4'
        />
      )}
    </>
  );
};

export default PackageView;
